module.exports = __webpack_public_path__ + "img/roll-1242.961be1a1.png";